<template>
  <div>
    <h3 class="componentTitle">宣传信息</h3>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <a-form-item label="标题">
        <a-input v-decorator="['newsTitle']" placeholder="请输入喜报标题" :maxLength="30" />
        <p class="tips">系统已自动生成喜报标题，可手动修改</p>
      </a-form-item>
      <a-form-item label="客户评价">
        <div>
          <a-input v-decorator="['comment']" style="width: calc(100% - 100px)" placeholder="请输入客户评价" :maxLength="30" />
          <a-checkbox v-model="commentVisible" @change="e => changVal({e,field: 'commentVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
        </div>
        <p class="tips">根据实际实用场景，可不局限于客户评价</p>
      </a-form-item>
      <a-form-item label="宣传语">
        <a-input v-decorator="['propaganda']" placeholder="请输入宣传语" :maxLength="30" />
        <p class="tips">系统已自动生成宣传语，可手动修改</p>
      </a-form-item>
      <a-form-item label="分公司名称">
        <div>
          <a-input v-decorator="['factoryName']" placeholder="请输入分公司名称" style="width: calc(100% - 100px)" :maxLength="30" />
          <a-checkbox v-model="factoryNameVisible" @change="e => changVal({e,field: 'factoryNameVisible'})" style="width: 100px;text-align: right;">不展示</a-checkbox>
        </div>
        <p class="tips">系统已自动生成分公司名称，可手动修改</p>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapState,mapMutations } from 'vuex';
export default {
  components: {},
  props: ['detail','pigLineProductResult'],
  data() {
    return {
      form: this.$form.createForm(this),
      commentVisible: false,
      factoryNameVisible: false,
    }
  },
  watch: {
    detail: {
      handler(){
        this.setForm()
      },
      deep: true,
    },
    modelKey(val){
      let {city,customerName=''} = this.detail || {}
      let firstName = customerName.slice(0,1)
      let newsTitle = `恭喜${city}${firstName}老板，养殖取得好效果！`
      if(val === '2') newsTitle = `恭喜${city}${firstName}老板，养殖取得好效果，料肉比${this.weightCostRatio}！`
      this.form.setFieldsValue({newsTitle})
    },
    weightCostRatio(){
      if(this.modelKey === '2'){
        let {city,customerName=''} = this.detail || {}
        let firstName = customerName.slice(0,1)
        let newsTitle = `恭喜${city}${firstName}老板，养殖取得好效果，料肉比${this.weightCostRatio}！`
        this.form.setFieldsValue({newsTitle})
      }
    },
  },
  computed: {
    ...mapState('news', ['newsData','modelKey','weightCostRatio']),
  },
  created() {},
  mounted() {
    this.setForm()
  },
  methods: {
    ...mapMutations('news', ['setState','changVal']),
    setForm(){
      let {city,customerName='',factoryName} = this.detail || {}
      let {weightCostRatio} = this.newsData || {}
      let firstName = customerName.slice(0,1)
      let newsTitle = `恭喜${city}${firstName}老板，养殖取得好效果！`
      if(this.modelKey === '2') newsTitle = `恭喜${city}${firstName}，养殖取得好效果，料肉比${weightCostRatio}`
      this.form.setFieldsValue({newsTitle,comment: '客户评价：肠道好、长速快、料比低',propaganda: '养猪希望富 希望来帮助',factoryName})
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>